import Aos from "aos";
import React, { useEffect } from "react";
import logo from "../../assets/gele4.png";
function Community(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <div className="flex p-20 pb-1 md:pb-0 w-full flex-col md:flex-row justify-between bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 ">
      <div className="w-full">
        <h1 className="text-white font-bold text-3xl md:text-[40px]">
          Join the community
        </h1>
        <p className="text-white text-2xl md:text-[20px] mt-5">
          MekaVerse Discord already has over 200,000 members! If you want to
          join the #MEKAGANG it’s here. Join us to get the news as soon as
          possible and follow our latest announcements.
        </p>
        <button className="btn md:px-5 md:py-3 px-2 py-3 mt-5 text-white bg-[#4753d6] hover:bg-sky-700 ">
          Join our Discord
        </button>
      </div>

      <div className="w-2/3">
        <img
          data-aos="slide-up"
          className="mt-[-30px] w-full md:w-2/3 hidden md:block"
          src={logo}
          alt=""
        />
      </div>
    </div>
  );
}

export default Community;
